import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/shekhawati.jpg";
import Newsletter from "../../shared/Newsletter";

const Shekhawati = () => {
  return (
    <>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Shekhawati
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Nawalgarh</li>
                      <li>Dundlod</li>
                      <li>Mandawa</li>
                      <li>Fatehpur</li>
                      <li>Chirawa</li>
                      <li>Sikar</li>
                      <li>Khetri</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Shekhawati
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Shekhawati is known not only for its frescoes and beautiful
                    wall painted havelis, thus making it open air art gallery,
                    but also because of its business tycoons and enterpreneurial
                    spirit of its people. This is a semi desert region in north
                    Rajasthan and it is situated entirely in the triangle
                    between Delhi-Bikaner-Jaipur. Shekhawati is a region and not
                    just a town or fort; it takes its name after its ruler Rao
                    Shekha. Shekhawati means the garden of Shekha. The towns of
                    Shekhawati are eminent for their amazing painted havelis.
                    Such is the appeal of the havelis that this region is dubbed
                    as "open art gallery of Rajasthan". The plethora of painted
                    Havelis in rich artistic tradition makes it commendable and
                    fascinating. Most of the buildings are dated from 18th
                    century to early 20th century. The Shekhawati landscape is
                    dotted with so many havelis that tracking them is something
                    like a treasure hunt.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Nawalgarh
                  </h2>

                  <p>
                    Founded in the 18th Century by Nawal Singh, it has some of
                    the finest frescos in the Shekhawati region. A huge fort
                    with colourful bazaar and numerous havelis with elaborate
                    architecture makes it an interesting destination for a 1day
                    / 1 night stay. There are a few prominent havelis like
                    Anandilal Poddar Haveli, Aath Haveli, Hodh Raj Patodia
                    Haveli etc., which are to be visited, and so are the two
                    forts and the palace hotel Roop Niwas that is a beautiful
                    heritage property and is renovated with modern facilities.
                    The Palace offers spacious painted rooms, Luxurious
                    interiors, graceful hospitality and great thematic evenings
                    with sumptuous cuisine. The registered painting in their Art
                    Gallery is a treat to the o visuals.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Places to visit in Nawalgarh Hawa Mahal <br />
                    Dundlod
                  </h2>
                  <p>
                    This quaint town is in the heart of the Shekhawati region.
                    The fort here was built in 1750. The Goenka Havelis and
                    other havelis here are adorned with beautiful frescos
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Mandawa
                  </h2>
                  <p>
                    An 18th century AD town, it has a fort, now a heritage
                    hotel. It houses interesting collection of traditional
                    costumes and armoury, and haveli architecture.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Fatehpur
                  </h2>
                  <p>
                    The frescoes of this region are unrivallled specially the
                    ones on the walls of the Devra and Singhania Havelis. These
                    Havelis splendidly combine Indian and western styles with
                    japanese Mount Fuji's paintings. Other havelis are Ram Gopal
                    Mahavir Prasad Goenka Haveli, Hukmi Chand Choudhari Haveli,
                    Jalan and Bharatiya Haveli.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Chirawa
                  </h2>
                  <p>
                    The Havelis worth seeing here are Rai Bahadur Tulsian
                    Haveli, Nemani Haveli, Mangal chand Dalmia Haveli, Tara
                    Chand Keshar Dev Dalmia Haveli, Manoharlal Vaidh Haveli,
                    Kakrania well and Shekhsaria well.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Sikar
                  </h2>
                  <p>
                    The Havelis worth seeing here are Rai Bahadur Tulsian
                    Haveli, Nemani Haveli, Mangal chand Dalmia Haveli, Tara
                    Chand Keshar Dev Dalmia Haveli, Manoharlal Vaidh Haveli,
                    Kakrania well and Shekhsaria well.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Khetri
                  </h2>
                  <p>
                  Raghunath temple, Bhopalgarh Fort, Sukh Mahal and Hari Singh Temple.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Shekhawati;
